import { GlobalAdminPrivilegePipe } from './global-admin.pipe';
import { HasAnyPermissionPipe, HasPermissionPipe } from './has-permission.pipe';
export * from './util';

export const PERMISSION_PIPES = [
    GlobalAdminPrivilegePipe,
    HasAnyPermissionPipe,
    HasPermissionPipe
];

export { GlobalAdminPrivilegePipe, HasPermissionPipe, HasAnyPermissionPipe };
